import { message } from "antd";
import { BasicUrl } from "config/config";

import _ from "lodash";

export const checkPermission = (pathname, permissionRoutes = []) => {
  return !!permissionRoutes.find(route => route === pathname);
};

export const getUrlDenyListByRole = (roleMenu = [], role = 1) => {
  const urlDenyList = [];
  roleMenu.forEach(data => {
    if (data.role > role) {
      urlDenyList.push(data.value);
    } else if (data.filterGroups) {
      const parentPath = data.value;
      data.filterGroups.forEach(group => {
        group.filters.forEach(filter => {
          if (filter.role > role) {
            urlDenyList.push(`${parentPath}/${filter.value}`);
          }
        });
      });
    }
  });
  return urlDenyList;
};

export const checkResponse = res => {
  return new Promise((resolve, reject) => {
    if (res.status >= 200 && res.status < 300) {
      resolve(res.data);
    }
    reject(res.statusText);
  });
};

export const checkResponseErr = err => {
  const msg = _.get(err, "message", "系统错误");
  console.log(err);
  return Promise.reject(msg);
};

export const getNoNullObj = obj => {
  Object.keys(obj).forEach(key => {
    if (obj[key] instanceof Object) {
      getNoNullObj(obj[key]);
    }
    if (obj[key] == null || obj[key] === undefined || obj[key] === "") {
      delete obj[key];
    }
  });
  return obj;
};

export const getMergeObj = obj => {
  const newObj = {};
  Object.keys(obj).forEach(key => {
    if (key.indexOf(".") > -1) {
      _.set(newObj, key, obj[key]);
    } else {
      newObj[key] = obj[key];
    }
  });
  return newObj;
};

export const formatNumber = (number, dotnum = 2) => {
  if (!Number(number)) {
    return 0;
  }
  const newNumber = number.toFixed(dotnum);
  return Number(newNumber);
};
/**
 *
 * @param {string} type [success, error, warning]
 * @param {*} msg
 */
export const showMessage = (type, msg) => {
  message[type](msg);
};

// 获取当前月份
export const nowMonth = () => {
  const date = new Date();
  const year = date.getFullYear();
  let month = date.getMonth() + 1;
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  const currentdate = `${year}-${month}`;
  return currentdate;
};
// 获取月份的第一天
export const firstDate = d => {
  const year = d.split("-")[0];
  const month = d.split("-")[1];
  return `${year}-${month}-01`;
};

// 获取月份最后一天
export const lastDate = d => {
  const year = d.split("-")[0];
  const month = d.split("-")[1];
  const day = new Date(year, month, 0).getDate();
  return year + "-" + month + "-" + (day < 10 ? "0" + day : day);
};

// 获取时间戳转变为年月日
export const timestampToTime = timestamp => {
  const date = new Date(timestamp); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
  const Y = date.getFullYear() + "-";
  const M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  const D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
  return Y + M + D;
};
// eslint-disable-next-line import/no-mutable-exports
export const baseUrl = `${BasicUrl[process.env.REACT_APP_CURRENT]}/api`;
export const baseDomain = BasicUrl[process.env.REACT_APP_CURRENT];

// if (process.env.REACT_APP_CURRENT === "test") {
//   // baseUrl = "http://test.qyconsult.treeyee.com/";
//   baseUrl = "https://test-front-base.survey.work/api";
//   // baseUrl = "http://test.qyconsult.treeyee.com";
//   baseDomain = "https://test-front-base.survey.work";
// } else if (process.env.NODE_ENV === "production") {
//   baseUrl = "https://survey.work/api";
//   baseDomain = "https://survey.work";
// }
//  各个项目模块对应值
export const modelArr = [
  {
    title: "检查吧",
    val: 1
  },
  {
    title: "问卷吧",
    val: 2
  },
  {
    title: "督导吧",
    val: 3
  },
  {
    title: "培训吧",
    val: 4
  }
];

export function openDownloadDialog(urlOrBlob, saveName) {
  let url;
  if (typeof urlOrBlob === "object" && urlOrBlob instanceof Blob) {
    url = URL.createObjectURL(urlOrBlob); // 创建blob地址
  } else {
    url = urlOrBlob;
  }
  const aLink = document.createElement("a");
  aLink.href = url;
  aLink.download = saveName || ""; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
  let event;
  if (window.MouseEvent) {
    event = new MouseEvent("click");
  } else {
    event = document.createEvent("MouseEvents");
    event.initMouseEvent(
      "click",
      true,
      false,
      window,
      0,
      0,
      0,
      0,
      0,
      false,
      false,
      false,
      false,
      0,
      null
    );
  }
  aLink.dispatchEvent(event);
}
export function hasMobile() {
  let isMobile = false;
  if (
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
  ) {
    // console.log('移动端');
    isMobile = true;
  }
  if (document.body.clientWidth < 800) {
    isMobile = true;
  }
  return isMobile;
}
// 获取短信验证码
const getShortMsg = (
  { appkey, scene, sessionId, sig, token },
  mobile,
  codeType
) => {
  window.axios
    .get("/alibaba/verificationCode", {
      params: {
        appkey,
        scene,
        mobile,
        sessionId,
        sig,
        token,
        codeType
      }
    })
    .then(res => {
      if (res.data.success) {
        message.success(res.data.message);
      } else {
        message.error(res.data.message);
      }
    });
};
export const AWSCValidate = (
  { width, appkey, scene, renderTo, mobile, codeType },
  handleSuccess
) => {
  window.AWSC.use("ic", (state, module) => {
    // 初始化
    window.ic = module.init({
      width,
      // 应用类型标识。它和使用场景标识（scene字段）一起决定了智能验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
      appkey,
      // 使用场景标识。它和应用类型标识（appkey字段）一起决定了智能验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的scene值，请务必正确填写。
      scene,
      // 声明智能验证需要渲染的目标元素ID。
      renderTo,
      // 验证通过时会触发该回调参数。您可以在该回调参数中将会话ID（sessionId）、签名串（sig）、请求唯一标识（token）字段记录下来，随业务请求一同发送至您的服务端调用验签。
      success(data) {
        // getShortMsg({ appkey, scene, ...data }, mobile, codeType);
        handleSuccess && handleSuccess(data);
      },
      // 验证失败时触发该回调参数
      fail(failCode) {
        console.log(failCode);
      },
      // 验证码加载异常时触发该回调参数
      error(errorCode) {
        console.log(errorCode);
      }
    });
  });
};
